import styled from 'styled-components';
import { Switch as AntdSwitch } from 'antd';

const Switch = styled(AntdSwitch)`
  min-width: 34px;
  height: 20px;

  & > .ant-switch-handle {
    width: 18px;
    height: 18px;
    top: 1px;
    left: 1px;
  }

  &.ant-switch-checked .ant-switch-handle {
    left: calc(100% - 18px - 1px);
  }
`;

export default Switch;
